import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";
import {
  LayoutContextProvider,
  LayoutContext,
} from "../context/LayoutContextProvider";
import { Modal, Button } from "antd";
import { updateTermsAndContionals } from "../services/user";
const Layout = () => {
  //Get local storage data if the user isn't accepted the terms and conditions show the modal
  const [isTermAccepted, setIsTermAccepted] = useState(
    localStorage.getItem("isTermAccepted")
  );
  const { activeSidebar, setActiveSidebar, user, setUser } =
    React.createContext(LayoutContext);
  const [modal, setModal] = useState(false);
  const [scrollDown, setScrollDown] = useState(false);

  //If the user click the button Accept the modal will be closed and sent the data to the server
  const handleAccept = async () => {
    await updateTermsAndContionals(true)
      .then(() => {
        localStorage.setItem("isTermAccepted", true);
        setIsTermAccepted(true);
        setModal(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  //If the user click the button Cancel the logout action will be call and the modal will be closed and the user will be redirected to the login page
  const handleCancel = async () => {
    await updateTermsAndContionals(false)
      .then(() => {
        document.cookie.split(";").forEach((c) => {
          document.cookie = c
            .replace(/^ +/, "")
            .replace(
              /=.*/,
              "=;expires=" + new Date().toUTCString() + ";path=/"
            );
        });

        localStorage.clear();
        window.location.href = "/login";
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (Math.round(scrollTop) + clientHeight === scrollHeight) {
      setScrollDown(true);
    } else {
      setScrollDown(false);
    }
  };

  useEffect(() => {
    if (
      isTermAccepted === "false" ||
      isTermAccepted === null ||
      isTermAccepted === "null"
    ) {
      setModal(true);
    }
  }, [isTermAccepted]);

  const getModal = () => {
    return (
      <>
        <Modal
          title="Términos y Condiciones"
          open={modal}
          footer={null}
          closable={false}
          maskClosable={false}
          keyboard={false}
          width={800}
          height={400}
        >
          <div
            className="modal-body"
            style={{
              maxHeight: "400px",
              overflowY: "scroll",
              maxWidth: "800px",
            }}
            onScroll={handleScroll}
          >
            <div className="scroll">
              <p>
                ARS Primera ha desarrollado la presente herramienta con el
                objetivo de facilitar las gestiones asignadas a los empleados y
                áreas que le son autorizadas el uso de la esta. En ese sentido,
                es necesario establecer los términos y condiciones de uso de la
                herramienta:
              </p>
              <p>
                Uso de la plataforma: El acceso a la herramienta está limitado
                para uso exclusivo de los empleados y áreas autorizadas por el
                administrador de la herramienta, por lo que el usuario se
                compromete a no prestar sus credenciales a terceros no
                autorizados para tales fines.
              </p>
              <p>
                Confidencialidad: El usuario se compromete a mantener en
                absoluta reserva e irrestricta confidencialidad todos los datos
                e información a los que acceda de manera directa y/o
                indirectamente a través de la herramienta utilizada para sus
                funciones.
              </p>
              <p>
                Responsabilidad: Los empleados usuarios son responsables de
                administrar y utilizar la herramienta para las funciones propias
                de su posición o área, apegados a la ética y a las políticas y
                procedimientos de la empresa.
              </p>
              <p>
                Actualización y mantenimiento: En caso de vulnerabilidad,
                errores o problemas técnicos que presente la herramienta el
                usuario deberá reportar al equipo de TIC para su debida
                solución. Además, se debe establecer un protocolo para las
                actualizaciones y mantenimiento, que garanticen su
                funcionamiento óptimo.
              </p>
              <p>
                Propiedad intelectual: El usuario reconoce que la plataforma y
                todos sus componentes, incluye de manera enunciativa pero no
                limitativo software, diseños, logotipos y demás contenido, están
                protegidos por los derechos patrimoniales y son propiedad
                exclusiva de la empresa.
              </p>
              <p>
                Restricciones de uso: El administrador de la herramienta podrá a
                su discreción limitar la cantidad y/o el tipo de datos que
                pueden ser analizados con esta, así como también sobre el tiempo
                de acceso o cualquier otra restricción relevante.
              </p>
              <p>
                Terminación de acceso: La empresa se reserva el derecho de
                revocar el acceso a la herramienta en cualquier momento,
                especialmente si el usuario incumple con los términos de uso o
                si se produce una terminación laboral.
              </p>
              <p>
                Cumplimiento legal: Los usuarios se compromete a cumplir con
                todas las leyes, regulaciones y políticas y procedimientos
                implementadas por la empresas, respecto a la privacidad,
                tratamiento y seguridad de los datos, así como cualquier otra
                normativa aplicable.
              </p>
            </div>
          </div>

          <div className="modal-footer" style={{ marginTop: "15px" }}>
            <Button
              type="primary"
              onClick={handleAccept}
              style={{ marginRight: "5px" }}
            >
              Aceptar
            </Button>
            <Button type="default" onClick={handleCancel}>
              Declinar
            </Button>
          </div>
        </Modal>
      </>
    );
  };
  return (
    <>
      <LayoutContext.Provider
        value={{ activeSidebar, setActiveSidebar, user, setUser }}
      >
        <Header />

        {!modal && (
          <Sidebar
            id="menu-item2"
            id1="menu-items2"
            activeClassName="patient-list"
          />
        )}

        <div className="page-wrapper">
          <div className="content">{!modal && <Outlet />}</div>
        </div>
        {getModal()}
      </LayoutContext.Provider>
    </>
  );
};

export default Layout;
